import * as moment from 'moment';

export class SiValidator {
  validator = [];

  emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
  quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;

  emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
  quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;

  displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;

  creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;

  isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
  isbn13Maybe = /^(?:[0-9]{13})$/;

  macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;

  ipv4Maybe = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  ipv6Block = /^[0-9A-F]{1,4}$/i;

  uuid = {
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
  };

  alpha = /^[A-Z]+$/i;
  alphanumericPattern = /^[0-9A-Z]+$/i;
  numericPattern = /^[-+]?[0-9]+$/;
  int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
  float = /^(?:[-+]?(?:[0-9]+))?(?:\.[0-9]*)?(?:[eE][\+\-]?(?:[0-9]+))?$/;
  hexadecimal = /^[0-9A-F]+$/i;
  decimal = /^[-+]?([0-9]+|\.[0-9]+|[0-9]+\.[0-9]+)$/;
  hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;

  ascii = /^[\x00-\x7F]+$/;
  multibyte = /[^\x00-\x7F]/;
  fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;

  surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;

  base64 = /^(?:[A-Z0-9+\/]{4})*(?:[A-Z0-9+\/]{2}==|[A-Z0-9+\/]{3}=|[A-Z0-9+\/]{4})$/i;

  phones = {
    'zh-CN': /^(\+?0?86\-?)?((13\d|14[57]|15[^4,\D]|17[678]|18\d)\d{8}|170[059]\d{7})$/,
    'zh-TW': /^(\+?886\-?|0)?9\d{8}$/,
    'en-ZA': /^(\+?27|0)\d{9}$/,
    'en-AU': /^(\+?61|0)4\d{8}$/,
    'en-HK': /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/,
    'fr-FR': /^(\+?33|0)[67]\d{8}$/,
    'pt-PT': /^(\+351)?9[1236]\d{7}$/,
    'el-GR': /^(\+?30)?(69\d{8})$/,
    'en-GB': /^(\+?44|0)7\d{9}$/,
    'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
    'en-ZM': /^(\+26)?09[567]\d{7}$/,
    'ru-RU': /^(\+?7|8)?9\d{9}$/,
    'nb-NO': /^(\+?47)?[49]\d{7}$/,
    'nn-NO': /^(\+?47)?[49]\d{7}$/,
    'vi-VN': /^(0|\+?84)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
    'en-NZ': /^(\+?64|0)2\d{7,9}$/,
    'en-IN': /^(\+?91|0)?[789]\d{9}$/
  };

  // from http://goo.gl/0ejHHW
  iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

  defaultEmailOptions = {
    allow_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true
  };

  defaultFqdnOptions = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false
  };

  defaultUrlOptions = {
    protocols: ['http', 'https', 'ftp'],
    require_tld: true,
    require_protocol: false,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false
  };

  defaultCurrencyOptions = {
    symbol: '$',
    require_symbol: false,
    allow_space_after_symbol: false,
    symbol_after_digits: false,
    allow_negatives: true,
    parens_for_negatives: false,
    negative_sign_before_digits: false,
    negative_sign_after_digits: false,
    allow_negative_sign_placeholder: false,
    thousands_separator: ',',
    decimal_separator: '.',
    allow_space_after_digits: false
  };

  defaultNormalizeEmailOptions = {
    lowercase: true,
    remove_dots: true,
    remove_extension: true
  };

  use(key: any, args: any[]): Function {
    args[0] = this.toString(args[0]);
    return this[key].apply(this, args);
  }

  toString(input: any): string {
    if (typeof input === 'object' && input !== null && input.toString) {
      input = input.toString();
    } else if (input === null || typeof input === 'undefined' || (isNaN(input) && !input.length)) {
      input = '';
    }

    return '' + input;
  }

  toDate(date: any): any {
    if (Object.prototype.toString.call(date) === '[object Date]') {
      return date;
    }

    date = Date.parse(date);
    return !isNaN(date) ? new Date(date) : null;
  }

  toFloat(str: string): number {
    return parseFloat(str);
  }

  toInt(str: string, radix?: number): number {
    return parseInt(str, radix || 10);
  }

  toBoolean(str: string, strict?: boolean): boolean {
    if (strict) {
      return str === '1' || str === 'true';
    }

    return str !== '0' && str !== 'false' && str !== '';
  }

  equals(str: string, comparison: any): boolean {
    return str === this.toString(comparison);
  }

  contains(str: string, elem: any): boolean {
    return str.indexOf(this.toString(elem)) >= 0;
  }

  matches(str: string, pattern: any, modifiers: any): boolean {
    if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
      pattern = new RegExp(pattern, modifiers);
    }

    return pattern.test(str);
  }

  isEmail(str: string, options?: any): boolean {
    options = this.validatorMerge(options, this.defaultEmailOptions);

    if (options.allow_display_name) {
      const displayEmail = str.match(this.displayName);
      if (displayEmail) {
        str = displayEmail[1];
      }
    }

    const parts = str.split('@');
    const domain = parts.pop();
    let user = parts.join('@');

    const lowerDomain = domain.toLowerCase();
    if (lowerDomain === 'gmail.com' || lowerDomain === 'googlemail.com') {
      user = user.replace(/\./g, '').toLowerCase();
    }

    if (
      !this.isByteLength(user, 0, 64) ||
      !this.isByteLength(domain, 0, 256)
    ) {
      return false;
    }

    if (!this.isFQDN(domain, {require_tld: options.require_tld})) {
      return false;
    }

    if (user[0] === '"') {
      user = user.slice(1, user.length - 1);
      return options.allow_utf8_local_part ?
        this.quotedEmailUserUtf8.test(user) :
        this.quotedEmailUser.test(user);
    }

    const pattern = options.allow_utf8_local_part ? this.emailUserUtf8Part : this.emailUserPart;

    const userParts = user.split('.');
    for (let i = 0; i < userParts.length; i++) {
      if (!pattern.test(userParts[i])) {
        return false;
      }
    }

    return true;
  }

  isURL(url: string, options?: any): boolean {
    if (url === undefined || url === null || url === '') {
      return true;
    }

    if (url.length >= 2083 || /\s/.test(url)) {
      return false;
    }

    options = this.validatorMerge(options, this.defaultUrlOptions);
    let split = url.split('://');
    if (split.length > 1) {
      const protocol = split.shift();
      if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
        return false;
      }
    } else if (options.require_protocol) {
      return false;
    } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
      split[0] = url.substr(2);
    }

    url = split.join('://');
    split = url.split('#');
    url = split.shift();

    split = url.split('?');
    url = split.shift();

    split = url.split('/');
    url = split.shift();
    split = url.split('@');
    if (split.length > 1) {
      const auth = split.shift();
      if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
        return false;
      }
    }

    const hostname = split.join('@');
    split = hostname.split(':');
    const host = split.shift();
    if (split.length) {
      const portStr = split.join(':');
      const port = parseInt(portStr, 10);
      if (!/^[0-9]+$/.test(portStr) || port <= 0 || port > 65535) {
        return false;
      }
    }

    if (!this.isIP(host) && !this.isFQDN(host, options) && host !== 'localhost') {
      return false;
    }

    if (options.host_whitelist &&
      options.host_whitelist.indexOf(host) === -1) {
      return false;
    }

    if (options.host_blacklist &&
      options.host_blacklist.indexOf(host) !== -1) {
      return false;
    }

    return true;
  }

  isMACAddress(str: string): boolean {
    return this.macAddress.test(str);
  }

  isIP(str: string, version?: any): boolean {
    version = this.toString(version);
    if (!version) {
      return this.isIP(str, 4) || this.isIP(str, 6);
    }

    if (version === '4') {
      if (!this.ipv4Maybe.test(str)) {
        return false;
      }

      const parts = str.split('.').sort((a, b) => {
        return parseInt(a, 10) - parseInt(b, 10);
      });
      return parseInt(parts[3], 10) <= 255;
    }

    if (version === '6') {
      const blocks = str.split(':');
      let foundOmissionBlock = false; // marker to indicate ::

      // At least some OS accept the last 32 bits of an IPv6 address
      // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
      // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
      // and '::a.b.c.d' is deprecated, but also valid.
      const foundIPv4TransitionBlock = this.isIP(blocks[blocks.length - 1], 4);
      const expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

      if (blocks.length > expectedNumberOfBlocks) {
        return false;
      }

      // initial or final ::
      if (str === '::') {
        return true;
      }

      if (str.substr(0, 2) === '::') {
        blocks.shift();
        blocks.shift();
        foundOmissionBlock = true;
      } else if (str.substr(str.length - 2) === '::') {
        blocks.pop();
        blocks.pop();
        foundOmissionBlock = true;
      }

      for (let i = 0; i < blocks.length; ++i) {
        // test for a :: which can not be at the string start/end
        // since those cases have been handled above
        if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
          if (foundOmissionBlock) {
            return false; // multiple :: in address
          }

          foundOmissionBlock = true;
        } else if (foundIPv4TransitionBlock && i == blocks.length - 1) {
          // it has been checked before that the last
          // block is a valid IPv4 address
        } else if (!this.ipv6Block.test(blocks[i])) {
          return false;
        }
      }

      if (foundOmissionBlock) {
        return blocks.length >= 1;
      }

      return blocks.length === expectedNumberOfBlocks;
    }

    return false;
  }

  isFQDN(str: string, options?: any): boolean {
    options = this.validatorMerge(options, this.defaultFqdnOptions);

    /* Remove the optional trailing dot before checking validity */
    if (options.allow_trailing_dot && str[str.length - 1] === '.') {
      str = str.substring(0, str.length - 1);
    }

    const parts = str.split('.');
    if (options.require_tld) {
      const tld = parts.pop();
      if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
        return false;
      }
    }

    let part;
    for (let i = 0; i < parts.length; i++) {
      part = parts[i];
      if (options.allow_underscores) {
        if (part.indexOf('__') >= 0) {
          return false;
        }

        part = part.replace(/_/g, '');
      }

      if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
        return false;
      }

      if (/[\uff01-\uff5e]/.test(part)) {
        // disallow full-width chars
        return false;
      }

      if (part[0] === '-' || part[part.length - 1] === '-') {
        return false;
      }

      if (part.indexOf('---') >= 0 && part.slice(0, 4) !== 'xn--') {
        return false;
      }
    }

    return true;
  }

  isBoolean(str: any): boolean {
    return (['true', 'false', '1', '0'].indexOf(str) >= 0);
  }

  isAlpha(str: any): boolean {
    return this.alpha.test(str);
  }

  isAlphanumeric(str: any): boolean {
    return this.alphanumericPattern.test(str);
  }

  isNumeric(str: any): boolean {
    return this.numericPattern.test(str);
  }

  isDecimal(str: any): boolean {
    return str !== '' && this.decimal.test(str);
  }

  isHexadecimal(str: any): boolean {
    return this.hexadecimal.test(str);
  }

  isHexColor(str: any): boolean {
    return this.hexcolor.test(str);
  }

  isLowercase(str: string): boolean {
    return str === str.toLowerCase();
  }

  isUppercase(str: string): boolean {
    return str === str.toUpperCase();
  }

  isInt(str: any, options?: any): boolean {
    options = options || {};
    return (str === undefined || str === null || str === '')
      || this.int.test(str)
      && (!options.hasOwnProperty('min') || str >= options.min)
      && (!options.hasOwnProperty('max') || str <= options.max);
  }

  isFloat(str: any, options?: any): boolean {
    options = options || {};
    return (str === undefined || str === null || str === '')
      || this.float.test(str)
      && (!options.hasOwnProperty('min') || str >= options.min)
      && (!options.hasOwnProperty('max') || str <= options.max);
  }

  isDivisibleBy(str: any, num: any): boolean {
    return this.toFloat(str) % this.toInt(num) === 0;
  }

  isNull(str: any): boolean {
    return str.length === 0;
  }

  isLength(str: any, min: any, max: any): boolean {
    const surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
    const len = str.length - surrogatePairs.length;
    return len >= min && (typeof max === 'undefined' || len <= max);
  }

  isByteLength(str: string, min: number, max: number): boolean {
    const len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
  }

  isUUID(str: any, version: any): boolean {
    const pattern = this.uuid[version ? version : 'all'];
    return pattern && pattern.test(str);
  }

  getTimezoneOffset(str: any): number {
    const iso8601Parts = str.match(this.iso8601);
    let timezone;
    let sign;
    let hours;
    let minutes;
    if (!iso8601Parts) {
      str = str.toLowerCase();
      timezone = str.match(/(?:\s|gmt\s*)(-|\+)(\d{1,4})(\s|$)/);
      if (!timezone) {
        return str.indexOf('gmt') !== -1 ? 0 : null;
      }

      sign = timezone[1];
      let offset = timezone[2];
      if (offset.length === 3) {
        offset = '0' + offset;
      }
      if (offset.length <= 2) {
        hours = 0;
        minutes = parseInt(offset, 10);
      } else {
        hours = parseInt(offset.slice(0, 2), 10);
        minutes = parseInt(offset.slice(2, 4), 10);
      }
    } else {
      timezone = iso8601Parts[21];
      if (!timezone) {
        return null;
      }

      if (timezone === 'z' || timezone === 'Z') {
        return 0;
      }

      sign = iso8601Parts[22];
      if (timezone.indexOf(':') !== -1) {
        hours = parseInt(iso8601Parts[23], 10);
        minutes = parseInt(iso8601Parts[24], 10);
      } else {
        hours = 0;
        minutes = parseInt(iso8601Parts[23], 10);
      }
    }
    return (hours * 60 + minutes) * (sign === '-' ? 1 : -1);
  }

  isDate(str: any): boolean {
    const parsedDate = Date.parse(str);
    if (isNaN(parsedDate)) {
      return false;
    }

    let normalizedDate = new Date(parsedDate);

    // normalizedDate is in the user's timezone. Apply the input
    // timezone offset to the date so that the year and day match
    // the input
    const timezoneOffset = this.getTimezoneOffset(str);
    if (timezoneOffset !== null) {
      const timezoneDifference = normalizedDate.getTimezoneOffset() - timezoneOffset;
      normalizedDate = new Date(normalizedDate.getTime() + 60000 * timezoneDifference);
    }

    const day = String(normalizedDate.getDate());
    //check for valid double digits that could be late days
    //check for all matches since a string like '12/23' is a valid date
    //ignore everything with nearby colons
    const dayOrYearMatches = str.match(/(^|[^:\d])[23]\d([^:\d]|$)/g);
    if (!dayOrYearMatches) {
      return true;
    }

    const dayOrYear = dayOrYearMatches.map((digitString) => {
      return digitString.match(/\d+/g)[0];
    }).join('/');

    const year = String(normalizedDate.getFullYear()).slice(-2);
    if (dayOrYear === day || dayOrYear === year) {
      return true;
    }

    if ((dayOrYear === (day + '/' + year)) || (dayOrYear === (year + '/' + day))) {
      return true;
    }

    return false;
  }

  isAfter(str: any, date: any): boolean {
    const comparison = this.toDate(date || new Date());
    const original = this.toDate(str);
    return !!(original && comparison && original > comparison);
  }

  isBefore(str: any, date: any): boolean {
    const comparison = this.toDate(date || new Date());
    const original = this.toDate(str);
    return !!(original && comparison && original < comparison);
  }

  isIn(str: any, options?: any): boolean {
    let i;
    if (Object.prototype.toString.call(options) === '[object Array]') {
      const array = [];
      for (i in options) {
        array[i] = this.toString(options[i]);
      }

      return array.indexOf(str) >= 0;
    }

    if (typeof options === 'object') {
      return options.hasOwnProperty(str);
    }

    if (options && typeof options.indexOf === 'function') {
      return options.indexOf(str) >= 0;
    }

    return false;
  }

  isWhitelisted(str: string, chars: string): boolean {
    for (let i = str.length - 1; i >= 0; i--) {
      if (chars.indexOf(str[i]) === -1) {
        return false;
      }
    }

    return true;
  }

  isCreditCard(str: any): boolean {
    const sanitized = str.replace(/[^0-9]+/g, '');
    if (!this.creditCard.test(sanitized)) {
      return false;
    }

    let sum = 0;
    let digit;
    let tmpNum;
    let shouldDouble;
    for (let i = sanitized.length - 1; i >= 0; i--) {
      digit = sanitized.substring(i, (i + 1));
      tmpNum = parseInt(digit, 10);
      if (shouldDouble) {
        tmpNum *= 2;
        if (tmpNum >= 10) {
          sum += ((tmpNum % 10) + 1);
        } else {
          sum += tmpNum;
        }
      } else {
        sum += tmpNum;
      }

      shouldDouble = !shouldDouble;
    }

    return !!((sum % 10) === 0 ? sanitized : false);
  }

  isISBN(str: any, version: any): boolean {
    version = this.toString(version);
    if (!version) {
      return this.isISBN(str, 10) || this.isISBN(str, 13);
    }

    const sanitized = str.replace(/[\s-]+/g, '');
    let checksum = 0;
    let i;
    if (version === '10') {
      if (!this.isbn10Maybe.test(sanitized)) {
        return false;
      }

      for (i = 0; i < 9; i++) {
        checksum += (i + 1) * sanitized.charAt(i);
      }

      if (sanitized.charAt(9) === 'X') {
        checksum += 10 * 10;
      } else {
        checksum += 10 * sanitized.charAt(9);
      }

      if ((checksum % 11) === 0) {
        return !!sanitized;
      }
    } else if (version === '13') {
      if (!this.isbn13Maybe.test(sanitized)) {
        return false;
      }

      const factor = [1, 3];
      for (i = 0; i < 12; i++) {
        checksum += factor[i % 2] * sanitized.charAt(i);
      }

      if (sanitized.charAt(12) - ((10 - (checksum % 10)) % 10) === 0) {
        return !!sanitized;
      }
    }

    return false;
  }

  isMobilePhone(str: any, locale: any): boolean {
    if (locale in this.phones) {
      return this.phones[locale].test(str);
    }

    return false;
  }

  isCurrency(str: any, options?: any): boolean {
    options = this.validatorMerge(options, this.defaultCurrencyOptions);

    return this.currencyRegex(options).test(str);
  }

  isJSON(str: any): boolean {
    try {
      const obj = JSON.parse(str);
      return !!obj && typeof obj === 'object';
    } catch (e) {
    }

    return false;
  }

  isMultibyte(str: any): boolean {
    return this.multibyte.test(str);
  }

  isAscii(str: any): boolean {
    return this.ascii.test(str);
  }

  isFullWidth(str: any): boolean {
    return this.fullWidth.test(str);
  }

  isHalfWidth(str: any): boolean {
    return this.halfWidth.test(str);
  }

  isVariableWidth(str: any): boolean {
    return this.fullWidth.test(str) && this.halfWidth.test(str);
  }

  isSurrogatePair(str: any): boolean {
    return this.surrogatePair.test(str);
  }

  isBase64(str: any): boolean {
    return this.base64.test(str);
  }

  isMongoId(str: any): boolean {
    return this.isHexadecimal(str) && str.length === 24;
  }

  isISO8601(str: any): boolean {
    return this.iso8601.test(str);
  }

  ltrim(str: any, chars: any): any {
    const pattern = chars ? new RegExp('^[' + chars + ']+', 'g') : /^\s+/g;
    return str.replace(pattern, '');
  }

  rtrim(str: any, chars: any): any {
    const pattern = chars ? new RegExp('[' + chars + ']+$', 'g') : /\s+$/g;
    return str.replace(pattern, '');
  }

  trim(str: any, chars: any): any {
    const pattern = chars ? new RegExp('^[' + chars + ']+|[' + chars + ']+$', 'g') : /^\s+|\s+$/g;
    return str.replace(pattern, '');
  }

  escape(str: any): any {
    return (str.replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\//g, '&#x2F;')
      .replace(/\`/g, '&#96;'));
  }

  stripLow(str: any, keepNewLines: any): any {
    const chars = keepNewLines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
    return this.blacklist(str, chars);
  }

  whitelist(str: any, chars: any): any {
    return str.replace(new RegExp('[^' + chars + ']+', 'g'), '');
  }

  blacklist(str: any, chars: any): any {
    return str.replace(new RegExp('[' + chars + ']+', 'g'), '');
  }


  normalizeEmail(email: string, options?: any): any {
    options = this.validatorMerge(options, this.defaultNormalizeEmailOptions);
    if (!this.isEmail(email)) {
      return false;
    }

    const parts = email.split('@', 2);
    parts[1] = parts[1].toLowerCase();
    if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
      if (options.remove_extension) {
        parts[0] = parts[0].split('+')[0];
      }

      if (options.remove_dots) {
        parts[0] = parts[0].replace(/\./g, '');
      }

      if (!parts[0].length) {
        return false;
      }

      parts[0] = parts[0].toLowerCase();
      parts[1] = 'gmail.com';
    } else if (options.lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    return parts.join('@');
  }

  validatorMerge(obj: any, defaults: any): any {
    obj = obj || {};
    for (let key in defaults) {
      if (typeof obj[key] === 'undefined') {
        obj[key] = defaults[key];
      }
    }

    return obj;
  }

  currencyRegex(options: any): any {
    const symbol = '(\\' + options.symbol.replace(/\./g, '\\.') + ')' + (options.require_symbol ? '' : '?');
    const negative = '-?';
    const wholeDollarAmountWithoutSep = '[1-9]\\d*';
    const wholeDollarAmountWithSep = '[1-9]\\d{0,2}(\\' + options.thousands_separator + '\\d{3})*';
    const validWholeDollarAmounts = ['0', wholeDollarAmountWithoutSep, wholeDollarAmountWithSep];
    const wholeDollarAmount = '(' + validWholeDollarAmounts.join('|') + ')?';
    const decimalAmount = '(\\' + options.decimal_separator + '\\d{2})?';
    let pattern = wholeDollarAmount + decimalAmount;

    // default is negative sign before symbol, but there are two other options (besides parens)
    if (options.allow_negatives && !options.parens_for_negatives) {
      if (options.negative_sign_after_digits) {
        pattern += negative;
      }
      else if (options.negative_sign_before_digits) {
        pattern = negative + pattern;
      }
    }

    // South African Rand, for example, uses R 123 (space) and R-123 (no space)
    if (options.allow_negative_sign_placeholder) {
      pattern = '( (?!\\-))?' + pattern;
    } else if (options.allow_space_after_symbol) {
      pattern = ' ?' + pattern;
    } else if (options.allow_space_after_digits) {
      pattern += '( (?!$))?';
    }

    if (options.symbol_after_digits) {
      pattern += symbol;
    } else {
      pattern = symbol + pattern;
    }

    if (options.allow_negatives) {
      if (options.parens_for_negatives) {
        pattern = '(\\(' + pattern + '\\)|' + pattern + ')';
      } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
        pattern = negative + pattern;
      }
    }

    return new RegExp(
      '^' +
      // ensure there's a dollar and/or decimal amount, and that it doesn't start with a space or a negative sign followed by a space
      '(?!-? )(?=.*\\d)' +
      pattern +
      '$'
    );
  }

  length(str: any, param1?: number, param2?: number): boolean {
    return (str === undefined || str === null || str === '') || (str.length >= param1 && str.length <= param2);
  }

  required(str: any): boolean {
    return str !== undefined && str !== '';
  }

  true(str: any): boolean {
    return str == 'true';
  }

  past(str: any): boolean {
    if (str) {
      let time = null;
      if (parseInt(str) == str) {
        time = moment(parseInt(str));
      } else {
        time = moment(str);
      }

      return time ? time.isBefore(moment(), 'day') : true;
    }

    return true;
  }

  pastToday(str: any): boolean {
    if (str) {
      let time = null;
      if (parseInt(str) == str) {
        time = moment(parseInt(str));
      } else {
        time = moment(str);
      }

      return time ? time.isSameOrBefore(moment(), 'day') : true;
    }

    return true;
  }

  pastOrNow(str: any): boolean {
    if (str) {
      let time = null;
      if (parseInt(str) == str) {
        time = moment(parseInt(str));
      } else {
        time = moment(str);
      }

      return time.isSameOrBefore(moment());
    }

    return true;
  }

  future(str: any): boolean {
    if (str) {
      let time = null;
      if (parseInt(str) == str) {
        time = moment(parseInt(str));
      } else {
        time = moment(str);
      }

      return moment().subtract(10, 'm').isBefore(time);
    }

    return true;
  }

  futureToday(str: any): boolean {
    if (str) {
      let time = null;
      if (parseInt(str) == str) {
        time = moment(parseInt(str));
      } else {
        time = moment(str);
      }

      return time.valueOf() >= moment().startOf('day').valueOf();
    }

    return true;
  }

  notNull(str: any): boolean {
    return str !== undefined && str !== '';
  }

  notNullCheck(str: string): boolean {
    return this.true(str);
  }

  notNullCheckMultiple(str: string): boolean {
    if (!str) {
      return false;
    }

    return !!str.split(',').find(bool => this.true(bool));
  }

  notBlank(str: any): boolean {
    return !(str && (str.trim() === '')); //this is only back verification (str !== undefined) && (str === '');
  }

  alphabetical(str: any): boolean {
    return (str === null) || (str === '') || (str.match(/\d+/) === null);
  }

  numeric(str: any): boolean {
    return (str === null) || (str === '') || this.isNumeric(str);
  }

  pattern(str: any, patt: any): boolean {
    const re = new RegExp(patt);
    return (str == null) || (str == '') || re.test(str);
  }

  email(str: string): boolean {
    const re = new RegExp('(?:[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])');
    return (str == null) || (str == '' || re.test(str));
  }

  checkDatesOutbound(str: any, scopeValue: any): boolean {
    if (str && scopeValue) {
      const returnDate = scopeValue;
      const outboundDate = moment(new Date(str));
      return moment(outboundDate).isSameOrBefore(returnDate, 'day');
    }

    return true;
  }

  checkDatesReturn(str: any, scopeValue: any): boolean {
    if (str && scopeValue) {
      const returnDate = moment(new Date(str));
      const outboundDate = scopeValue;
      return moment(returnDate).isSameOrAfter(outboundDate, 'day');
    }

    return true;
  }

  alphanumeric(str: any): boolean {
    return (str === undefined || str === null || str === '') || this.isAlphanumeric(str);
  }

  minmax(str: any, param1?: number, param2?: number): boolean {
    str = parseInt(str, 10);
    return isNaN(str) || str >= param1 && str <= param2;
  }

  firstCharacterIsLetter(str: any): boolean {
    return (str === null) || (str === '') || (str[0].match(/\d+/) === null);
  }

  specialCharacter(str: any, patt: any): boolean {
    const re = new RegExp(patt);
    return (str == null) || (str == '') || !re.test(str);
  }

  nifNie(str: string): boolean {
    if (str === null || str === '') {
      return true;
    }

    const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
    const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
    const nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
    str = str.toString().toUpperCase();

    if (!nifRexp.test(str) && !nieRexp.test(str)) {
      return false;
    }

    const nie = str
      .replace(/^[X]/, '0')
      .replace(/^[Y]/, '1')
      .replace(/^[Z]/, '2');

    const letter = str.substr(-1);
    const charIndex = parseInt(nie.substr(0, 8)) % 23;

    return validChars.charAt(charIndex) === letter;
  }

  oneOrMoreUpperCase(str: string): boolean {
    return (str === undefined || str === null || str === '') || (str.match(/[A-Z\u00C0-\u00DC]+/) != null);
  }

  oneOrMoreNumbers(str: string): boolean {
    return (str === undefined || str === null || str === '') || (str.match(/\d+/) != null);
  }

  oneOrMoreSpecialCharacters(str: string): boolean {
    return (str === undefined || str === null || str === '') || (str.match(/\W+/) != null);
  }
}
